<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <h4>{{ 'farmer-insights.settings.title' | translate }}</h4>
  <div class="settings-container">
    <div class="spacing--margin-horizontal spacing--margin-vertical">
      <agr-summary-card
        title="{{ 'farmer-insights.settings.non-detailed-view-label' | translate }}"
      >
        <p>
          <i>{{ 'farmer-insights.settings.select-one-benchmark-label' | translate }}</i>
        </p>
        <div class="settings-item">
          <mat-form-field class="flex__child--auto spacing--margin-right countrySelector">
            <mat-select
              [hideSingleSelectionIndicator]="true"
              data-placeholder="{{ 'farmer-insights.benchmark-settings' | translate }}"
              data-test="benchmark-settings-non-detailed-select"
              formControlName="nonDetailedBenchmark"
            >
              <mat-option
                *ngFor="let benchmark of benchmarkOptions$ | async"
                [value]="benchmark.value"
              >
                {{ benchmark.label | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </agr-summary-card>
    </div>
    <div class="spacing--margin-horizontal spacing--margin-vertical">
      <agr-summary-card title="{{ 'farmer-insights.settings.detailed-view-label' | translate }}">
        <p>
          <i>{{ 'farmer-insights.settings.select-multiple-benchmark-label' | translate }}</i>
        </p>
        <div class="settings-item" *ngIf="showAgrifirmBenchmarks$ | async">
          <div>
            <mat-icon>info_outline</mat-icon>
            <span>{{ translateLabel('farmer-insights.settings.selected-period-label') }}</span>
          </div>
          <mat-slide-toggle
            [hideIcon]="true"
            data-test="benchmark-selected-period-slider"
            color="primary"
            class="text--small flex__child-auto spacing--padding-right"
            formControlName="selectedPeriod"
          >
          </mat-slide-toggle>
        </div>
        <div class="settings-item" *ngIf="showAgrifirmBenchmarks$ | async">
          <div>
            <mat-icon>info_outline</mat-icon>
            <span>{{ translateLabel('farmer-insights.settings.last-weeks-label') }}</span>
          </div>
          <mat-slide-toggle
            [hideIcon]="true"
            data-test="benchmark-last-weeks-slider"
            color="primary"
            class="text--small flex__child-auto spacing--padding-right"
            formControlName="lastWeeks"
          >
          </mat-slide-toggle>
        </div>
        <div class="settings-item">
          <div>
            <mat-icon>info_outline</mat-icon>
            <span>{{
              'farmer-insights.settings.customer-average-selected-period-label' | translate
            }}</span>
          </div>
          <mat-slide-toggle
            [hideIcon]="true"
            data-test="benchmark-customer-average-selected-period-slider"
            color="primary"
            class="text--small flex__child-auto spacing--padding-right"
            formControlName="customerAverageSelectedPeriod"
          >
          </mat-slide-toggle>
        </div>
      </agr-summary-card>
    </div>
  </div>
</agr-form-dialog>
